<div class="home">

  <!-- ========================================================
       Hero
  ======================================================== -->
  <section class="home__hero">
    <div class="home__hero-bg" aria-hidden="true"></div>
    <div class="home__container home__hero-inner">
      <div class="home__hero-text">
        <div class="home__badge">
          <span class="home__badge-dot"></span>
          @if (geoState === 'granted' && ortLabel) {
            Mehrere verifizierte Betriebe · {{ ortLabel }}
          } @else {
            Viele verifizierte Betriebe · deutschlandweit
          }
        </div>
        <h1 class="home__headline">
          Handwerk,<br>
          <em>wie es sein sollte.</em>
        </h1>
        <p class="home__subline">
          Vertrauenswürdige Handwerksbetriebe in deiner Nähe. Transparenter Preis, Termin sofort buchbar.
        </p>
      </div>

      <!-- Mobile search pill -->
      <button class="home__search-pill" (click)="onSuche()" aria-label="Suche öffnen">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
        <div class="home__search-pill-text">
          <span class="home__search-pill-main">{{ selectedGewerk?.label || 'Welches Gewerk?' }}</span>
          <span class="home__search-pill-sub">{{ ortInput || 'Wo?' }}</span>
        </div>
        <div class="home__search-pill-btn">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
        </div>
      </button>

      <!-- Desktop search bar -->
      <form class="home__search-bar" (ngSubmit)="onSuche()">

        <!-- Was brauchst du? — Gewerk autocomplete -->
        <div class="home__search-field">
          <label class="home__search-label">Was brauchst du?</label>
          <input
            type="text"
            [(ngModel)]="gewerkInput"
            name="gewerkInput"
            placeholder="Elektrik, Sanitär…"
            class="home__search-input"
            (input)="onGewerkInput()"
            (focus)="onGewerkFocus()"
            (blur)="onGewerkBlur()"
            autocomplete="off"
            aria-label="Gewerk"
            aria-autocomplete="list"
            aria-haspopup="listbox"
          />
          @if (gewerkDropdownOpen && filteredGewerke.length > 0) {
            <ul class="home__autocomplete" role="listbox">
              @for (g of filteredGewerke; track g.id) {
                <li
                  class="home__autocomplete-item"
                  (mousedown)="selectGewerk(g)"
                  role="option"
                  [attr.aria-selected]="selectedGewerk?.id === g.id"
                >
                  <app-gewerk-icon [gewerkId]="g.id" [size]="16" />
                  {{ g.label }}
                </li>
              }
            </ul>
          }
        </div>

        <div class="home__search-sep" aria-hidden="true"></div>

        <!-- Wo? — Nominatim autocomplete -->
        <div class="home__search-field">
          <label class="home__search-label">Wo?</label>
          <input
            type="text"
            [(ngModel)]="ortInput"
            name="ortInput"
            placeholder="Düsseldorf, 40213…"
            class="home__search-input"
            (input)="onOrtInput()"
            (focus)="onOrtFocus()"
            (blur)="onOrtBlur()"
            autocomplete="off"
            aria-label="Ort"
            aria-autocomplete="list"
            aria-haspopup="listbox"
          />
          @if (ortDropdownOpen && ortSuggestions.length > 0) {
            <ul class="home__autocomplete" role="listbox">
              @for (s of ortSuggestions; track s.mapboxId) {
                <li
                  class="home__autocomplete-item"
                  (mousedown)="selectOrt(s)"
                  role="option"
                >
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s7-7 7-12a7 7 0 0 0-14 0c0 5 7 12 7 12Z"/><circle cx="12" cy="10" r="2.5"/></svg>
                  <span>
                    <strong>{{ s.name }}</strong>
                    @if (s.placeFormatted && s.placeFormatted !== s.name) {
                      <span class="home__autocomplete-sub"> · {{ s.placeFormatted }}</span>
                    }
                  </span>
                </li>
              }
            </ul>
          }
        </div>

        <!-- Wann? — deaktiviert für v1 -->
        <!--
        <div class="home__search-sep" aria-hidden="true"></div>
        <div class="home__search-field home__search-field--narrow">
          <label class="home__search-label">Wann?</label>
          <input type="text" placeholder="Heute" class="home__search-input" aria-label="Datum" />
        </div>
        -->

        <button type="submit" class="home__search-submit">
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
          Suchen
        </button>
      </form>
    </div>
  </section>

  <!-- ========================================================
       Emergency Strip
  ======================================================== -->
  <div class="home__section home__section--tight">
    <div class="home__container">
      <a class="home__emergency" routerLink="/notfall" aria-label="Notfall — Sofort-Hilfe vom Handwerker">
        <div class="home__emergency-icon">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2 4 14h7l-1 8 9-12h-7l1-8Z"/></svg>
        </div>
        <div class="home__emergency-text">
          <span class="home__emergency-title">Notfall — Sofort-Hilfe</span>
          <span class="home__emergency-sub">Wasserrohrbruch, Heizungsausfall, Türöffnung, Glasbruch oder Verstopfung. Festpreis ab 149 €. Verfügbarkeit live in deiner PLZ.</span>
        </div>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.8)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 5l7 7-7 7"/></svg>
      </a>
    </div>
  </div>

  <!-- ========================================================
       Gewerke Grid
  ======================================================== -->
  <section class="home__section">
    <div class="home__container">
      <div class="home__section-head">
        <div>
          <h2 class="home__section-title">Nach Gewerk stöbern</h2>
          <p class="home__section-sub">Vom Wasserrohrbruch bis zur Holztreppe — alle Gewerke, ein Ort.</p>
        </div>
      </div>

      @if (gewerke.length > 0) {
        <app-kategorie-grid
          [gewerke]="gewerke"
          (kategorieSelected)="onKategorieSelected($event)"
          (alleSelected)="onAlleGewerke()"
        />
      } @else {
        <div class="home__gewerke-placeholder">
          @for (_ of [1,2,3,4,5,6,7,8,9,10,11,12]; track $index) {
            <div class="home__skeleton-block home__skeleton-block--card"></div>
          }
        </div>
      }
    </div>
  </section>

  <!-- ========================================================
       Near you — nur rendern, wenn Betriebe existieren (oder noch
       geladen wird). Leerer Zustand → komplett aus dem DOM.
  ======================================================== -->
  @if (naheLoading || naheHandwerker.length > 0) {
  <section class="home__section">
    <div class="home__container">
      <div class="home__section-head">
        <div>
          <h2 class="home__section-title">
            @if (ortLabel) {
              In deiner Nähe · {{ ortLabel }}
            } @else {
              Beliebte Betriebe
            }
          </h2>
          <p class="home__section-sub">
            @switch (geoState) {
              @case ('granted') { Basierend auf deinem Standort · 50 km Umkreis }
              @case ('pending')  { Standort wird ermittelt … }
              @case ('denied')   { Standortzugriff abgelehnt — wir zeigen dir eine Auswahl aus ganz Deutschland }
              @case ('unsupported') { Standortdienst nicht verfügbar — Auswahl aus ganz Deutschland }
              @default { Aktiviere deinen Standort für eine Trefferliste in deiner Nähe }
            }
          </p>
        </div>
        <div class="home__section-actions">
          @if (geoState === 'idle' || geoState === 'denied') {
            <button type="button" class="home__section-geobtn" (click)="tryUseGeolocation()" aria-label="Meinen Standort verwenden">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M12 22s7-7 7-12a7 7 0 0 0-14 0c0 5 7 12 7 12Z"/><circle cx="12" cy="10" r="2.5"/>
              </svg>
              Standort verwenden
            </button>
          }
          <a routerLink="/suche" class="home__section-link">
            Alle ansehen
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 5l7 7-7 7"/></svg>
          </a>
        </div>
      </div>

      @if (naheLoading) {
        <div class="home__hw-grid">
          @for (_ of [1,2,3,4]; track $index) {
            <div class="home__skeleton-card">
              <div class="home__skeleton-block home__skeleton-block--img"></div>
              <div class="home__skeleton-block home__skeleton-block--line"></div>
              <div class="home__skeleton-block home__skeleton-block--line home__skeleton-block--short"></div>
            </div>
          }
        </div>
      } @else {
        <div class="home__hw-grid">
          @for (h of naheHandwerker; track h.id) {
            <app-handwerker-karte [handwerker]="h" />
          }
        </div>
      }
    </div>
  </section>
  }

  <!-- ========================================================
       How it works
  ======================================================== -->
  <section class="home__how">
    <div class="home__container">
      <h2 class="home__how-title">In 2 Minuten zur Anfrage. In 24 Stunden zum Angebot.</h2>
      <div class="home__how-grid">
        <div class="home__how-step">
          <div class="home__how-meta">
            <span class="home__how-num">01 / 03</span>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--cr-green-700)" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="6" width="18" height="14" rx="2"/><circle cx="12" cy="13" r="4"/><path d="M9 6l1.5-2h3L15 6"/></svg>
          </div>
          <h3 class="home__how-step-title">Anliegen beschreiben</h3>
          <p class="home__how-step-sub">Foto, Adresse, Wunschtermin. Ohne Anmeldung loslegen.</p>
        </div>
        <div class="home__how-step">
          <div class="home__how-meta">
            <span class="home__how-num">02 / 03</span>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--cr-green-700)" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><circle cx="4" cy="6" r="1"/><circle cx="4" cy="12" r="1"/><circle cx="4" cy="18" r="1"/></svg>
          </div>
          <h3 class="home__how-step-title">Festpreise erhalten</h3>
          <p class="home__how-step-sub">Mehrere Handwerksbetriebe — verifiziert, bewertet, mit verbindlichem Preis.</p>
        </div>
        <div class="home__how-step">
          <div class="home__how-meta">
            <span class="home__how-num">03 / 03</span>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--cr-green-700)" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2 4 5v7c0 5 4 9 8 10 4-1 8-5 8-10V5l-8-3Z"/><path d="m9 12 2 2 4-4"/></svg>
          </div>
          <h3 class="home__how-step-title">Sicher zahlen</h3>
          <p class="home__how-step-sub">Treuhänderisch — Geld wird erst freigegeben, wenn der Auftrag erledigt ist.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- ========================================================
       Suchtyp-Modal
  ======================================================== -->
  @if (showSuchtypModal) {
    <app-suchtyp-modal
      [gewerkLabel]="selectedGewerk?.label || (gewerkInput.trim() || null)"
      [ortLabel]="ortInput.trim() || null"
      (guidedSelected)="onSuchtypGuided()"
      (selfSelected)="onSuchtypSelf()"
      (closed)="onSuchtypClosed()"
    />
  }

  <!-- ========================================================
       Trust Promises — vier strukturelle Aussagen statt
       erfundener Bestandszahlen. Alle ab Tag 1 belegbar.
  ======================================================== -->
  <section class="home__section">
    <div class="home__container">
      <div class="home__stats">
        <div class="home__stat">
          <div class="home__stat-num">0 €</div>
          <div class="home__stat-label">Anfrage stellen — kostet dich nichts</div>
        </div>
        <div class="home__stat">
          <div class="home__stat-num">24 h</div>
          <div class="home__stat-label">Erste Angebote werktags</div>
        </div>
        <div class="home__stat">
          <div class="home__stat-num">100 %</div>
          <div class="home__stat-label">Festpreis vorab — keine Überraschungen</div>
        </div>
        <div class="home__stat">
          <div class="home__stat-num">Geprüft</div>
          <div class="home__stat-label">Identität, Gewerbe &amp; Qualifikation</div>
        </div>
      </div>
    </div>
  </section>

</div>
